module.exports = "<div class=\"modelpic\">\n  <a ui-sref=\"model({modelId: model.id})\" ng-if=\"$root.isMember\"><img ng-src=\"{{$root.BASE_CONTENT + model.image}}\" alt=\"{{model.name}}\"></a>\n  <img ng-if=\"!$root.isMember\" ng-src=\"{{$root.BASE_CONTENT + model.image}}\" alt=\"{{model.name}}\">\n</div>\n<div class=\"model_details\">\n  <h3>\n    <a ui-sref=\"model({modelId: model.id})\" ng-if=\"$root.isMember\">{{model.name}}</a>\n    <a ng-if=\"!$root.isMember\">{{model.name}}</a>\n  </h3>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./~/core_theme_2/src/templates/directives/modelBlock.html
// module id = 167
// module chunks = 0